import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import { DatePipe, NgStyle, NgIf, SlicePipe } from "@angular/common";
import { Router } from "@angular/router";
import { Incidencias } from "src/app/shared/model/incidencias/incidencia.model";
import { Constantes } from "src/app/utilerias/constantes/constantes";
import { MatTooltip } from "@angular/material/tooltip";
@Component({
  selector: "app-card-inc-qa",
  templateUrl: "./card-incQA.component.html",
  styleUrls: ["./card-incQA.component.css"],
  providers: [DatePipe],
  imports: [MatTooltip, NgStyle, NgIf, SlicePipe],
  standalone: true,
})
export class CardIncQAComponent implements OnInit, OnDestroy {
  constructor(private router: Router) {}

  @Input() inc: Incidencias;
  @Input() color: String;
  @Input() proyecto: any;

  ngOnInit() {}

  ngOnDestroy() {}

  public number(valor: number): boolean {
    return valor > Constantes.CERO;
  }

  detallesIncidenciaQA(row: Incidencias) {
    this.router.navigate(["/INCIDENCIAS/INC_QA/detalle", row.id], {
      state: { incidencia: row, proyecto: this.proyecto },
    });
  }
}
